import { api } from "./client";

export type MonitorView = "grid" | "list";
// По какво се оцветяват редовете на екрана на монитора.
export type MonitorColorBy = "table" | "waiter" | "none";

export interface Monitor {
  id: number;
  userId: number;
  stationIds: number[];
  aggregatedQuantities: boolean;
  completeFullQuantity: boolean;
  view: MonitorView;
  // Смислено само за шпикер монитор (users.shpicker): вижда ли екранът и
  // незапочнато/в процес, или само от „Сготвено" нататък.
  showAllStatuses: boolean;
  colorBy: MonitorColorBy;
  // Разделен екран: лявата/дясната половина слушат свои станции. stationIds
  // е ВИНАГИ обединението им (BE го извежда при запис); при splitScreen=false
  // двата списъка са празни.
  splitScreen: boolean;
  leftStationIds: number[];
  rightStationIds: number[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateMonitorRequest {
  userId: number;
  stationIds: number[];
  aggregatedQuantities: boolean;
  completeFullQuantity: boolean;
  view: MonitorView;
  showAllStatuses: boolean;
  colorBy: MonitorColorBy;
  // При splitScreen=true BE изисква и двете половини непразни и сам извежда
  // stationIds като тяхното обединение.
  splitScreen: boolean;
  leftStationIds: number[];
  rightStationIds: number[];
}

export interface UpdateMonitorRequest {
  userId: number;
  stationIds: number[];
  aggregatedQuantities: boolean;
  completeFullQuantity: boolean;
  view: MonitorView;
  showAllStatuses: boolean;
  colorBy: MonitorColorBy;
  splitScreen: boolean;
  leftStationIds: number[];
  rightStationIds: number[];
}

export interface MonitorInfoStation {
  id: number;
  name: string;
}

export interface MonitorInfoResponse {
  userId: number;
  stationIds: number[];
  stations: MonitorInfoStation[];
  aggregatedQuantities: boolean;
  completeFullQuantity: boolean;
  view?: MonitorView;
  showAllStatuses?: boolean;
  colorBy?: MonitorColorBy;
  // Флагът users.shpicker от org DB — екранът е шпикер (агрегиращ) монитор.
  isShpicker?: boolean;
  // Разделен екран (виж Monitor) — опционални за съвместимост със стар BE.
  splitScreen?: boolean;
  leftStationIds?: number[];
  rightStationIds?: number[];
}

export const createMonitor = async (
  data: CreateMonitorRequest
): Promise<Monitor> => {
  const response = await api.post<Monitor>("/monitors/", data);
  return response.data;
};

export const updateMonitor = async (
  monitorId: number,
  data: UpdateMonitorRequest
): Promise<Monitor> => {
  const response = await api.put<Monitor>(`/monitors/${monitorId}`, data);
  return response.data;
};

export const deleteMonitor = async (monitorId: number): Promise<void> => {
  await api.delete(`/monitors/${monitorId}`);
};

export const getMonitors = async (): Promise<Monitor[]> => {
  const response = await api.get<Monitor[]>("/monitors/");
  return response.data;
};

export const getMonitorInfo = async (
  userId: number
): Promise<MonitorInfoResponse> => {
  const response = await api.get<MonitorInfoResponse>(
    `/monitors/info/${userId}`
  );
  return response.data;
};
